import styled from 'styled-components';

const HiddenUntilToggledWrapper = styled.div`
  height: ${(props) => (props.layerCtrlsOpen ? '65px' : '1px')};
  opacity: ${(props) => (props.layerCtrlsOpen ? 1 : 0)};
  visibility: ${(props) => (props.layerCtrlsOpen ? 'visible' : 'hidden')};
  margin-bottom: 0px !important;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  transition: all 0.2s ease-in;
`;

const StyledMapButton = styled.button.attrs((props) => ({
  id: props.id,
  title: props.title,
  type: 'button',
}))`
  display: flex !important;
  justify-content: center;
  align-items: center;
  margin: 0px 1px 0px 0px !important;
  height: 32px !important;

  :focus {
    outline-width: 0px;
  }
`;

const StyledRefocusButton = styled(StyledMapButton)`
  background-color: transparent;
  width: 100%;
  margin: unset !important;
  :hover {
    background-color: rgba(16, 25, 56, 0.85);
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
`;

const StandAloneButton = styled(StyledMapButton)`
  width: 32px;
  height: 32px;
  border-radius: 4px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: rgba(16, 25, 56, 0.5);

  margin: 0px 20px 10px 0px !important;

  :hover {
    background-color: rgba(16, 25, 56, 0.85);
  }

  :focus {
    border-radius: 0px;
  }
`;

const MapLayerButton = styled(StandAloneButton)`
  border-top-left-radius: ${(props) => (props.layerCtrlsOpen ? '0px' : '4px')};
  border-top-right-radius: ${(props) => (props.layerCtrlsOpen ? '0px' : '4px')};
`;

const TopMapButton = styled(StyledMapButton)`
  :hover {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
`;

const BottomMapButton = styled(StyledMapButton)`
  border-bottom: 1px solid #ddd !important;
`;

const StyledMapButtonImg = styled.img.attrs({
  alt: '',
})`
  height: ${(props) => (props.layerCtrlsOpen ? '20px' : '0px')};
  transition: all 0.3s linear;
`;

export {
  HiddenUntilToggledWrapper,
  StyledMapButton,
  StandAloneButton,
  TopMapButton,
  BottomMapButton,
  StyledMapButtonImg,
  StyledRefocusButton,
  MapLayerButton,
};
